import { defineComponent, h } from 'vue';
import { QInput, QSelect, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import { WithProxy } from '@/Shared/helperClasses';

export default defineComponent({
    name: 'string-lookup-list',
    components: { QInput, QSelect, QIcon },
    data: function () {
        return {
            condition_expn: null,
            list: null,
            lookupurl: null,
            lookupexpn: null,
            displayexpn: null,
            displayfield: null,
            valueexpn: null,
            valuefield: null,
            valuetemp: null,
        }
    },
    created() {
        if (this.schema.formatData.LookupType === 'URL' || (!this.schema.formatData.LookupType && this.schema.formatData.LookupURL))
            this.lookupurl = utils.compile(this, this.schema.formatData.LookupURL);
        else if (this.schema.formatData.LookupType === 'Interpolated')
            this.lookupexpn = utils.compileExpression(this, this.schema.formatData.LookupInterpolatedExpression);

        const modelAs = this.schema.formatData.LookupModelAs || 'cmodel';
        if (this.schema.formatData.DisplayType === 'Expression')
        //  this.displayexpn = utils.compileExpression(this, this.schema.formatData.DisplayExpression);
            this.displayexpn = new Function('context', modelAs, 'with (context) return ' + this.schema.formatData.DisplayExpression + ';');
        else
            this.displayfield = new Function(modelAs, 'return ' + modelAs + '.' + (this.schema.formatData.DisplayField || 'Name'));

        if (!this.schema.formatData.ValueType || this.schema.formatData.ValueType === 'Expression')
        //  this.valueexpn = utils.compileExpression(this, this.schema.formatData.ValueExpression); //new Function(modelAs, 'return ' + this.schema.formatData.ValueExpression);
            this.valueexpn = new Function('context', modelAs, 'with (context) return ' + this.schema.formatData.ValueExpression + ';');
        else
            this.valuefield = new Function(modelAs, 'return ' + modelAs + '.' + (this.schema.formatData.ValueField || 'Value'));
    },
    async mounted() {
        this.Refresh();
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        sync(prop, value) {
            console.log(`lookupList.sync('${prop}', '${value}')`);

            this.valuetemp = value;

            let v = value;
            if (v == '!!null!!') v = null;

            if (Array.isArray(this.cmodel))
            {
                if (prop < this.cmodel.length)
                    this.cmodel[prop] = v;
                else {
                    while (this.cmodel.length < prop)
                        this.cmodel.push(null);

                    this.cmodel.push(v);
                }
            }
            else
            {
                this.cmodel[prop] = v;
            }
        },
        onBlur(isfocused,e) {
            debugger;
        },
        getItemProps(item) {
            return {
                title: item.text,
                value: item.value,
                disabled: item.disabled,
            };
        },
        async Refresh() {
            if (this.lookupurl)
            {
                this.list = await utils.api.get(utils.evaluate(this.lookupurl, this), false, this.schema.formatData.CacheLookupResult);
            }
            else if (this.lookupexpn)
            {
                this.list = utils.evaluate(this.lookupexpn, this, false);
            }

            if (this.list && typeof this.list === 'object' && !Array.isArray(this.list))
            {
                // Convert our object into an array using Key and Value
                this.list = Object.keys(this.list).reduce((out, key) => {
                    out.push({
                        Key: key,
                        Value: this.list[key]
                    });
                    return out;
                }, []);
            }

            this.valuetemp = this.cmodel[this.schemakey];
        }
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        propertygrid: false,
    },
    render() {
        if (!this.Condition)
            return null;

        let desc;
        if (this.schema.description)
            desc = <i class="mdi mdi-information" title={this.schema.description} style={{ color: "var(--v-checkboxGrey-base)", fontSize: "small", marginLeft: "3px" }}></i>;

        let err;
        if (this.schema.formatData?.error)
            err = utils.tt(this.schema.formatData.error, <QIcon name="mdi-alert" size="xs" color="negative" />);

        const name = <span style={{ marginLeft: (this.child * 15) + "px" }}>{this.name}</span>;

        if (!this.list)
            return (
                <tr>
                    <td style={{ width: "1px" }}>
                        <span style={{ whiteSpace: "nowrap" }}>{name} {desc}</span>
                    </td>
                    <td class={{ "property-grid": this.propertygrid }} style={this.propertygrid ? { minWidth: 0 } : undefined}>
                        <QInput outlined dense hide-bottom-space
                            loading
                            class="caption pa-0 ma-0"
                            style={{ width: "100%" }}
                            modelValue={this.cmodel[this.schemakey]}
                            onUpdate:modelValue={(value) => this.sync(this.schemakey, value)} />
                    </td>
                </tr>
            );

        // <v-progress-linear indeterminate={true}></v-progress-linear>

        const items = [];
        //const choice = this.cmodel[this.schemakey];
        const schema = this.schema;

        const proxy = new WithProxy(this).proxy;

        //this.valuetemp = choice;

        if (schema.formatData && schema.formatData.AllowCustomInput) {
            for (var i = 0; i < this.list.length; i++) {
                const item = this.list[i];
                const value = this.valueexpn ? this.valueexpn(proxy, item) : this.valuefield(item);
                const txt = this.displayexpn ? this.displayexpn(proxy, item) : this.displayfield(item);

                items.push({
                    text: txt,
                    value: value,
                });
            }
            // xstyle={{ whiteSpace: "nowrap" }}
            return (
                <tr>
                    <td style={{ width: "1px" }}>
                        <span style={{ whiteSpace: "nowrap" }}>{name} {desc}{err}</span>
                    </td>
                    <td class={{ "property-grid": this.propertygrid }} style={this.propertygrid ? { minWidth: 0 } : undefined}>
                        <QSelect outlined dense hide-bottom-space
                            style={this.propertygrid ? { width: "100%", minWidth: 0 } : { minWidth: "150px" }}
                            popup-content-class="q-select-max-popup-height"
                            use-input
                            hide-selected
                            fill-input
                            autocomplete="off"
                            emit-value
                            map-options
                            modelValue={this.valuetemp}
                            options={items}
                            option-label="text"
                            option-value="value"
                            onInputValue={(value) => { this.valuetemp = value; this.sync(this.schemakey, value); }}
                            onUpdate:modelValue={(value) => { this.valuetemp = value; this.sync(this.schemakey, value); }}
                            onBlur={() => this.sync(this.schemakey, this.valuetemp)} />
                    </td>
                </tr>
            );
        }
        /*
            onKeyup={(e) => this.sync(this.schemakey, e.target ? e.target.value : e)}
            onUpdate:modelValue={(e) => this.sync(this.schemakey, e.target ? e.target.value : e)}
        */
        let found = false;
        for (var i = 0; i < this.list.length; i++) {
            const item = this.list[i];
            const value = this.valueexpn ? this.valueexpn(proxy, item) : this.valuefield(item);
            const txt = this.displayexpn ? this.displayexpn(proxy, item) : this.displayfield(item);

            if (this.valuetemp == value)
                found = true;

            items.push({
                text: txt,
                value: value,
                disabled: false,
            });
        }

        if (schema.$allows_null)
            items.splice(0, 0, { text: "", value: "!!null!!", disabled: false });
        else if (!found)
            items.splice(0, 0, { text: "Please choose one", value: this.valuetemp, disabled: true });

        return (
            <tr>
                <td style={{ width: "1px" }}>
                    <span style={{ whiteSpace: "nowrap" }}>{name} {desc}{err}</span>
                </td>
                <td class={{ "property-grid": this.propertygrid }} style={this.propertygrid ? { minWidth: 0 } : undefined}>
                    <QSelect
                        outlined dense hide-bottom-space
                        style={this.propertygrid ? { width: "100%", minWidth: 0 } : undefined}
                        modelValue={this.valuetemp}
                        popup-content-class="q-select-max-popup-height"
                        options={items}
                        option-label="text"
                        option-value="value"
                        emit-value
                        map-options
                        onUpdate:modelValue={(value) => this.sync(this.schemakey, value)} />
                </td>
            </tr>
        );
    }
});